import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { SiderbarComponent } from './siderbar/siderbar.component';
import { HeaderComponent } from './header/header.component';
import { ApibuttonComponent } from './apibutton/apibutton.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { OnlyLettersInputDirective } from '../directives/only-letters-input.directive'
import { OnlyNumbersInputDirective } from '../directives/only-numbers-input.directive';
import { ModalMessagesComponent } from './modal-messages/modal-messages.component'


@NgModule({
  declarations: [
    BreadcrumbsComponent,
    SiderbarComponent,
    HeaderComponent,
    ApibuttonComponent,
    SpinnerComponent,
    OnlyLettersInputDirective,
    OnlyNumbersInputDirective,
    ModalMessagesComponent,
  ],
  exports: [
    BreadcrumbsComponent,
    SiderbarComponent,
    HeaderComponent,
    ApibuttonComponent,
    SpinnerComponent,
    OnlyLettersInputDirective,
    OnlyNumbersInputDirective,
    ModalMessagesComponent,
  ],
  imports: [
    CommonModule
  ]
})
export class SharedModule { }
